import { t } from "i18next";

export const mapScopeOneFormDataToApiData = (formData) => {
  const apiData = [];

  formData.forEach(el => {
    apiData.push({
      id: el.id,
      consumption: {
        value: el.consumptionValue,
        measureId: el.consumptionMeasure
      },
      consumptionTypeId: el.consumptionType
    });
  });

  return apiData;
};

export const mapScopeTwoFormDataToApiData = (formData) => {
  const apiData = [];

  formData.forEach(el => {
    apiData.push({
      id: el.id,
      countryId: el.countryId,
      electricityType: el.electricityType,
      consumption: {
        value: el.consumptionValue,
        measureId: el.consumptionMeasure
      }
    });
  });

  return apiData;
};

export const defaultScopeOneGridColumns = [
  t("supplierQuestionnaire.consumptionBasedRevenue.gridHeaders.category"),
  t("supplierQuestionnaire.consumptionBasedRevenue.gridHeaders.value"),
  t("supplierQuestionnaire.consumptionBasedRevenue.gridHeaders.measure")
];

export const defaultScopeTwoGridColumns = [
  t("supplierQuestionnaire.consumptionBasedRevenue.gridHeaders.country"),
  t("supplierQuestionnaire.consumptionBasedRevenue.gridHeaders.category"),
  t("supplierQuestionnaire.consumptionBasedRevenue.gridHeaders.value"),
  t("supplierQuestionnaire.consumptionBasedRevenue.gridHeaders.measure")
];

export const SCOPES = Object.freeze({
  SCOPE_ONE: "SCOPE_ONE",
  SCOPE_TWO: "SCOPE_TWO"
});